export async function sendEmailNotification(message: string) {
  try {
    await fetch('/functions/v1/send-email-notification', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message }),
    });
  } catch (e) {
    console.error('Failed to send email notification', e);
  }
}

export async function sendSMSNotification(message: string) {
  try {
    await fetch('/functions/v1/send-sms-notification', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message }),
    });
  } catch (e) {
    console.error('Failed to send sms notification', e);
  }
}
